<!--
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-07-20 10:11:39
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-12 19:42:00
 * @FilePath: \mes-web\src\views\pm\components\common\CommonTimePicker.vue
 * @Description:时间选择器
-->
<template>
  <div class="pic">
    <el-date-picker v-model="date" ref="datePicker" type="date" :disabled="disabled" :prefix-icon="prefixIcon"
      :clear-icon="clearIcon" :editable="false" value-format="timestamp" :default-value="new Date()"
      :placeholder="placeholder" class="date-picker">
    </el-date-picker>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    needShow: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择时间'
    },
    clearIcon: {
      type: String,
      default: 'none'
    },
    prefixIcon: {
      type: String,
      default: 'none'
    },
    pickerOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    date: {
      get () {
        return this.value ? this.value * 1000 : null
      },
      set (val) {
        this.$emit('change', parseInt(val / 1000))
      }
    }
  },

  mounted () {
    if (!this.needShow)
      this.togglePanel()
  },
  methods: {
    togglePanel () {
      this.$refs.datePicker.focus()
    },
  }
}
</script>

<style lang="scss" scoped>
.default {
  width: 100%;

  &:hover {
    color: #07c160;
  }
}

.pic {
  position: relative;
}

/deep/.el-input {
  width: 100%;
}

/deep/.el-input__inner {
  text-align: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
</style>